<template>
	<div style="text-align:center;padding-top: 20%;">
		<el-button @click="gopay" type="success" v-if="showpay">立即支付</el-button>
		<orderpay ref="orderpay" @paycallback="paycallback"></orderpay>
	</div>
</template>

<script>
	import Utils from '../../lib/util.js';
	import orderpay from '@/components/cw/orderpay_online.vue';
	export default {
		components: {
			orderpay
		},
		props: {},
		data() {
			return {
				pkval:'',
				ratebatch:'',
				userid:'',
				showpay:true
			}
		},
		mounted() {
			if(this.$route.query!=undefined){
				if(this.$route.query.param!=undefined)
				{
					var param=this.$public.decrypt(this.$route.query.param);
					if(param!=''){
						var paramlist=param.split('★');
						this.userid=paramlist[0];
						this.ratebatch=paramlist[1];
						this.pkval=paramlist[2];
					}
				}
			}
		},
		methods:{
			gopay(){
				if(this.ratebatch!=''&&this.pkval!='')
					this.$refs.orderpay.init({ratebatch:this.ratebatch,pkval:this.pkval,userid:this.userid});
				else
					this.$tool.message('缺少参数',0);
			},
			paycallback(e){
				this.showpay=false;
				window.opener = null;
				window.open("about:blank", "_top").close();
			}
		}
	}
</script>

<style>
</style>